import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ListChecks, Settings } from "lucide-react";

const COLS = [
  { key: "not_started", label: "Not Started", cls: "text-slate-600" },
  { key: "in_progress", label: "In Progress", cls: "text-amber-700" },
  { key: "complete", label: "Complete", cls: "text-emerald-700" },
];

export default function EngagerBoard() {
  const [setups, setSetups] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/engager-setups").then((r) => setSetups(r.data)).catch(() => {}); }, []);
  return (
    <div className="p-8 max-w-6xl mx-auto space-y-6" data-testid="engager-board-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-cass-navy flex items-center gap-2"><ListChecks className="w-7 h-7 text-cass-teal" />Onboarding Board</h1>
          <p className="text-cass-slate mt-1">Every accepted proposal's Engager setup at a glance — so nothing slips.</p>
        </div>
        <Button variant="outline" onClick={() => nav("/engager")} data-testid="to-config-btn"><Settings className="w-4 h-4 mr-1" />Task Configuration</Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {COLS.map((col) => {
          const items = setups.filter((s) => s.status === col.key);
          return (
            <div key={col.key} data-testid={`board-col-${col.key}`}>
              <div className={`text-sm font-semibold mb-2 ${col.cls}`}>{col.label} <span className="text-cass-slate">({items.length})</span></div>
              <div className="space-y-3">
                {items.map((s) => (
                  <Card key={s.id} className="p-4 rounded-md cursor-pointer hover:shadow-md transition-shadow" onClick={() => nav(`/proposals/${s.proposal_id}`)} data-testid={`board-card-${s.id}`}>
                    <div className="font-medium text-cass-navy truncate">{s.client_name}</div>
                    <div className="text-xs text-cass-slate">{s.proposal_ref} · {s.owner_name || "—"}</div>
                    <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden my-2">
                      <div className="h-full bg-cass-teal" style={{ width: `${s.progress.percent}%` }} />
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-cass-slate">{s.progress.completed}/{s.progress.total} tasks</span>
                      <Badge variant="outline">{s.progress.percent}%</Badge>
                    </div>
                    {(() => {
                      const names = [...new Set((s.services || []).flatMap((g) => g.tasks || []).map((t) => t.assigned_user_name).filter(Boolean))];
                      return names.length ? (
                        <div className="flex flex-wrap gap-1 mt-2" data-testid={`board-assignees-${s.id}`}>
                          {names.map((nm) => <Badge key={nm} variant="secondary" className="text-[10px] font-normal">{nm}</Badge>)}
                        </div>
                      ) : null;
                    })()}
                  </Card>
                ))}
                {!items.length && <div className="text-xs text-cass-slate italic px-1">Nothing here.</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
